/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { CreateCreditNoteRequest } from '../models/create-credit-note-request';
import { CreditNoteResponse } from '../models/credit-note-response';

/**
 * credit Note APIs
 */
@Injectable({ providedIn: 'root' })
export class CreditNoteService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createInvoiceCreditNote()` */
  static readonly CreateInvoiceCreditNotePath = '/api/v1/credit-note/{id}';

  /**
   * Create credit note against an invoice.
   *
   * Create a credit note for invoice
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createInvoiceCreditNote()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createInvoiceCreditNote$Response(
    params: {
      /**
       * The invoice's id that needs to be credited
       */
      id: number;
      body: CreateCreditNoteRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<CreditNoteResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CreditNoteService.CreateInvoiceCreditNotePath,
      'post'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<CreditNoteResponse>;
        })
      );
  }

  /**
   * Create credit note against an invoice.
   *
   * Create a credit note for invoice
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createInvoiceCreditNote$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createInvoiceCreditNote(
    params: {
      /**
       * The invoice's id that needs to be credited
       */
      id: number;
      body: CreateCreditNoteRequest;
    },
    context?: HttpContext
  ): Observable<CreditNoteResponse> {
    return this.createInvoiceCreditNote$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<CreditNoteResponse>): CreditNoteResponse =>
          r.body
      )
    );
  }
}
